/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_User } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";
import utils, { TNonEmptyArray, TUserType } from "@graphql/helpers/utils.graphql";

type TUserCreateFunctions = {
  create: CommandResult_User;
};

export type TUserCreateMutations = {
  user: TUserCreateFunctions;
};

export const userCreate = (fields: TNonEmptyArray<TUserType>) => gql`
  mutation userCreate($user: UserCreateInputType!) {
    user {
      create(user: $user) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_User")}
`;

type TUserUpdateFunctions = {
  update: CommandResult_User;
};
export type TUserUpdateMutations = {
  user: TUserUpdateFunctions;
};
export const userUpdate = (fields: TNonEmptyArray<TUserType>) => gql`
  mutation userUpdate($user: UserUpdateInputType!) {
    user {
      update(user: $user) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_User")}
`;

type TUserDeleteFunctions = {
  customDelete: CommandResult_User;
};
export type TUserDeleteMutations = {
  user: TUserDeleteFunctions;
};
export const userDelete = () => gql`
  mutation userDelete($user: UserDeleteInputType!) {
    user {
      customDelete(user: $user) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;

type TUserHandleActiveFunctions = {
  handleActiveUser: CommandResult_User;
};
export type TUserHandleActiveMutations = {
  user: TUserHandleActiveFunctions;
};
export const userHandleActive = () => gql`
  mutation userHandleActive($user: UserUpdateInputType!) {
    user {
      handleActiveUser(user: $user) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;

type TUserEmailFunctions = {
  userEmail?: CommandResult_User;
  resendEmailConfirmation?: CommandResult_User;
};
export type TUserEmailMutations = {
  user: TUserEmailFunctions;
};
export const userForgotPassword = () => gql`
  mutation userForgotPassword($user: UserEmailInputType!) {
    user {
      userEmail(user: $user) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;

export const resendEmailConfirmation = () => gql`
  mutation resendEmailConfirmation($user: UserEmailInputType!) {
    user {
      resendEmailConfirmation(user: $user) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;
